import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// Sideloaded plan tiers need this schema; plan.tiers remains an array attribute, so the plan inverse is null.
const TierSchema = withDefaults({
  type: 'tier',
  fields: [
    { kind: 'attribute', name: 'fromCycle' },
    { kind: 'attribute', name: 'amount' },
    { kind: 'attribute', name: 'per' },
    { kind: 'attribute', name: 'percentage' },
    { kind: 'attribute', name: 'maximum' },
    { kind: 'attribute', name: 'overrideAmount' },
    { kind: 'attribute', name: 'overridePercentage' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    {
      kind: 'belongsTo',
      name: 'plan',
      type: 'plan',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default TierSchema;
